var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.675 8.403-5.93-6.088a1.04 1.04 0 0 0-1.372-.104l-.109.094-5.939 6.098a1.148 1.148 0 0 0 0 1.6c.42.431 1.108.44 1.539.02l4.024-4.132v14.995a1.113 1.113 0 1 0 2.225 0V5.891l4.004 4.113c.42.43 1.108.44 1.538.02l.02-.02a1.148 1.148 0 0 0 0-1.6z",
    fill: "#292A2C",
    fillRule: "evenodd"
  })));
};
export default SvgUp;